import { combineReducers } from "redux";
import cartReducer from "./Cart/reducer";
import { productReducer } from "./Product/reducer";

const rootStore = combineReducers({
  product: productReducer,
  cart: cartReducer,
});

export default rootStore;
